/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

class EnableMfaModel {
  constructor(data) {
    this.data = _.assign({}, {
      mobileNumber: '',
      country: 'US',
      mfaType: 'sms',
      mfaCode: '',
    }, data);
  }

  isMobileNumberGoodEnough() {
    return this.data.mobileNumber.length > 0;
  }

  isMfaCodeGoodEnough() {
    return this.data.mfaCode.length >= 6;
  }

  setMobileNumber(mobileNumber) {
    this.data.mobileNumber = mobileNumber;
  }

  getMobileNumber() {
    return this.data.mobileNumber;
  }

  setCountry(country = 'US') {
    this.data.country = country;
  }

  setMfaCode(mfaCode) {
    this.data.mfaCode = mfaCode;
  }

  getMfaCode() {
    return this.data.mfaCode;
  }

  getMfaType() {
    return this.data.mfaType;
  }

  bundleForSetMobileNumberApi() {
    return {
      iso2_code: this.data.country,
      mobile_number: this.data.mobileNumber,
      mfa_type: this.data.mfaType || 'sms',
    };
  }
}

export default EnableMfaModel;
